import {
    REGISTER,
    RegisterAction,
    RegisterError,
    RegisterResponse,
    REGISTER_ERROR,
    REGISTER_INITIAL,
    REGISTER_SUCCESS,
} from '../_types/register';

export const setRegisterInitial = (): RegisterAction => {
    return {
        type: REGISTER_INITIAL,
    };
};

export const setRegisterLoading = (): RegisterAction => {
    return {
        type: REGISTER,
    };
};

export const setRegisterError = (err: RegisterError): RegisterAction => {
    return {
        type: REGISTER_ERROR,
        payload: err,
    };
};

export const setRegisterSuccess = (data: RegisterResponse): RegisterAction => {
    return {
        type: REGISTER_SUCCESS,
        payload: data,
    };
};
